
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"26.9976","y":"11.001","width":"2.8281","height":"22.6248","rx":"1.41405","transform":"rotate(45 26.9976 11.001)","fill":"#212A4B"}}),_c('rect',{attrs:{"x":"11.0007","y":"12.9998","width":"2.8281","height":"22.6248","rx":"1.41405","transform":"rotate(-45 11.0007 12.9998)","fill":"#212A4B"}})])
          )
        }
      }
    